/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useContext } from "react";
import Actions from "./Actions/Actions";
import Conditions from "./Conditions/Conditions";
import Context from "../../../store/context";

export default function ListenerRule({ ruleState, setRule, event }) {
  const { isModalSidebar } = useContext(Context);
  const dispatch = (action) => {
    switch (action.type) {
      case "ruleLabel":
        setRule({
          ...ruleState,
          Label: action.label,
        });
        break;
      case "edit-actions":
        setRule({
          ...ruleState,
          Actions: action.data,
        });
        break;
      case "edit-conditions":
        setRule({
          ...ruleState,
          Conditions: action.data,
        });
        break;
      case "createContact":
        setRule({
          ...ruleState,
          createContact: {
            ...ruleState.createContact,
            [action.field]: action.value,
          },
        });
        break;
      default:
    }
  };

  return (
    <div className="form-group">
      <div className="row mb-4">
        <div className={isModalSidebar ? "col-12" : "col-xl-2"}>Label</div>
        <div className={isModalSidebar ? "col-12" : "col-xl-10"}>
          <input
            type="text"
            className="form-control rule-label"
            value={ruleState.Label}
            onChange={(e) =>
              dispatch({
                type: "ruleLabel",
                ruleId: ruleState.UUID,
                label: e.target.value,
              })
            }
          />
        </div>
      </div>

      <Conditions
        ruleState={ruleState}
        setConditions={(data) => dispatch({ type: "edit-conditions", data })}
        event={event}
      />

      <Actions
        event={event}
        ruleState={ruleState}
        setActions={(data) => dispatch({ type: "edit-actions", data })}
      />
    </div>
  );
}
